import store from '../vuex/store'

// 去百度地图
function goMap(addr) {
  window.open('http://api.map.baidu.com/geocoder?address='+addr+'&output=html&src=webapp.baidu.openAPIdemo');
}

// 打电话
function call(phone) {
  console.log(phone)
  window.location.href = "tel:"+phone;
}

// banner点击方法
function clickBanner(item){
  if(item.jumpUrl){
    window.open(item.jumpUrl, '_blank')
  }
}

export default {goMap,call,clickBanner};


// WEBPACK FOOTER //
// ./src/utils/change.js